<template>
  <div>
    <v-layout row wrap class="mb-4">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </v-layout>
    <v-card>
      <v-card-title>
        <div>
          <h3 class="headline mb-0">{{labels.vehicle}}</h3>
        </div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.vehRegNo}}</v-subheader>
              <div v-if="globalMotorForm.vehRegNo">{{globalMotorForm.vehRegNo}}</div>
              <div v-else> - </div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.vehUsg}}</v-subheader>
              <div>{{globalMotorForm.vehUsg}} - {{query.vehUsg}}</div>
            </v-flex>
            <v-flex xs6>
              <v-layout row wrap align-content-start>
                <v-flex xs12>
                  <v-subheader class="queryLabel">{{labels.vehMake}}</v-subheader>
                  <div>{{globalMotorForm.vehMake}} - {{query.vehMake}}</div>
                </v-flex>
                <v-flex xs12>
                  <v-subheader class="queryLabel">{{labels.vehModel}}</v-subheader>
                  <div>{{globalMotorForm.vehModel}} - {{query.vehModel}}</div>
                </v-flex>
                <v-flex xs12>
                  <v-subheader class="queryLabel">{{labels.vehValue}}</v-subheader>
                  <div v-if="globalMotorForm.vehValue !== null">{{$store.state.agency.quotation.commonInfo.currPrefix}}{{formatDisplayNumber(globalMotorForm.vehValue)}}</div>
                  <div v-else> - </div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6>
              <v-card color="grey lighten-4">
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xl6 lg7 xs8 class="modelInfo">
                      <v-icon>mdi-car-sports</v-icon>
                      <span>{{labels.vehBodyType}}</span>
                    </v-flex>
                    <v-flex xl6 lg5 xs4>
                      {{query.vehBodyType}}
                    </v-flex>
                    <v-flex xl6 lg7 xs8 class="modelInfo">
                      <v-icon>mdi-engine-outline</v-icon>
                      <span>{{labels.vehCapacity}}</span>
                    </v-flex>
                    <v-flex xl6 lg5 xs4>
                      {{query.vehCapacity}}
                    </v-flex>
                    <v-flex xl6 lg7 xs8 class="modelInfo">
                      <v-icon>mdi-weight</v-icon>
                      <span>{{labels.vehTonnage}}</span>
                    </v-flex>
                    <v-flex xl6 lg5 xs4>
                      {{query.vehTonnage}}
                    </v-flex>
                    <v-flex xl6 lg7 xs8 class="modelInfo">
                      <v-icon>mdi-seat-recline-normal</v-icon>
                      <span>{{labels.vehNoSeats}}</span>
                    </v-flex>
                    <v-flex xl6 lg5 xs4>
                      {{query.vehNoSeats}}
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-subheader class="queryLabel">{{labels.vehManuYr}}</v-subheader>
              <div v-if="globalMotorForm.vehManuYr !== null">{{globalMotorForm.vehManuYr}}</div>
              <div v-else> - </div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.vehRegMth}}</v-subheader>
              <div v-if="globalMotorForm.vehRegMth !== null">{{globalMotorForm.vehRegMth}}</div>
              <div v-else> - </div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.vehRegYr}}</v-subheader>
              <div v-if="globalMotorForm.vehRegYr !== null">{{globalMotorForm.vehRegYr}}</div>
              <div v-else> - </div>
            </v-flex>
            <v-flex xs6>
              <v-text-field v-model="motorForm.engineNo" :label="labels.engineNo" :error-messages="errors.collect('engineNo')" data-vv-name="engineNo" :data-vv-as="labels.engineNo" v-validate="'required|max:20'"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field v-model="motorForm.chassisNo" :label="labels.chassisNo" :error-messages="errors.collect('chassisNo')" data-vv-name="chassisNo" :data-vv-as="labels.chassisNo" v-validate="'required|max:25'"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-autocomplete :items="quoteParam.finInst" v-model="motorForm.finInst" :label="labels.finInst" item-text="label" item-value="value" data-vv-name="finInst" :data-vv-as="labels.finInst" :error-messages="errors.collect('finInst')" v-validate="'required'"></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-layout row wrap class="mt-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed">
        Next
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import { AGENCY_QUOTATION_LIFECYCLE, QUOTE_MOTOR_PARAM, QUOTE_MOTOR_VEHICLE } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import { formatDisplayNumber } from '@/utils/number'
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      labels: {
        vehicle: 'Vehicle Information',
        vehRegNo: 'Registration No.',
        vehMake: 'Make',
        vehModel: 'Model',
        vehBodyType: 'Body Type',
        vehCapacity: 'Capacity',
        vehTonnage: 'Tonnage',
        vehNoSeats: 'No. of Seats',
        vehManuYr: 'Manufacture Year',
        vehRegYr: 'Registration Year',
        vehRegMth: 'Registration Month',
        vehUsg: 'Usage',
        vehValue: 'Value',
        engineNo: 'Engine No.*',
        chassisNo: 'Chassis No.*',
        finInst: 'Finance Company*'
      },
      motorForm: {
        vehRegNo: undefined,
        vehMake: undefined,
        vehModel: undefined,
        vehManuYr: undefined,
        vehRegYr: undefined,
        vehRegMth: undefined,
        vehUsg: undefined,
        vehValue: undefined,
        engineNo: undefined,
        chassisNo: undefined,
        finInst: undefined
      },
      finInstLoading: false
    }
  },
  computed: {
    quoteParam() {
      return this.$store.state.agency.quotation.motorParam
    },
    globalMotorForm() {
      return this.$store.state.agency.quotation.motorForm
    },
    globalCommonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    query() {
      return this.$store.state.agency.quotation.queryInfo
    }
  },
  methods: {
    doInit() {
      this.getFinInst()

      // Default value from vuex store 1st
      this.motorForm.vehRegNo = this.globalMotorForm.vehRegNo
      this.motorForm.vehUsg = this.globalMotorForm.vehUsg
      this.motorForm.vehMake = this.globalMotorForm.vehMake
      this.motorForm.vehModel = this.globalMotorForm.vehModel
      this.motorForm.vehManuYr = this.globalMotorForm.vehManuYr
      this.motorForm.vehRegMth = this.globalMotorForm.vehRegMth
      this.motorForm.vehRegYr = this.globalMotorForm.vehRegYr
      this.motorForm.vehValue = this.globalMotorForm.vehValue
      this.motorForm.engineNo = this.globalMotorForm.engineNo
      this.motorForm.chassisNo = this.globalMotorForm.chassisNo
      this.motorForm.finInst = this.globalCommonForm.finInst
    },
    async getFinInst() {
      const apiURI = this.$store.state.agency.quotation.menu.finInst
      if (apiURI) {
        try {
          this.finInstLoading = true
          const expand = {
            startDate: formatDisplayDate(this.globalCommonForm.startDate)
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              finInst: data.data
            }
            this.$store.commit(QUOTE_MOTOR_PARAM, commitResult)
          }
          this.finInstLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.finInstLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    },
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
      this.$router.push({ name: 'motorProposalDriver' })
    },
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.commit(QUOTE_MOTOR_VEHICLE, this.motorForm)
          this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 4)
          this.$router.push({ name: 'motorProposalPremium' })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPartialSave() {
      try {
        this.$store.commit(QUOTE_MOTOR_VEHICLE, this.motorForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 3) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 3)
    }
    this.doInit()
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ]
}
</script>

<style lang="scss">
.modelInfo {
  span {
    padding-left: 10px;
  }
}
</style>
